import { TimeSlot } from "@clockwise/schema";

export enum Day {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}

export enum StartOrEndSlot {
  StartSlot = "StartSlot",
  EndSlot = "EndSlot",
}

export enum MeetingOrWorkingHours {
  MeetingHours = "meeting hours",
  WorkingHours = "working hours",
}

export enum WorkingHoursTypeEnum {
  Base = "Base",
  PreferredFocusTime = "PreferredFocusTime",
  Meeting = "Meeting",
}

export enum CopyButtonStyle {
  Compact = "Compact",
  Standard = "Standard",
}

export interface SlotRange {
  startSlot: TimeSlot;
  endSlot: TimeSlot;
  startError: boolean;
  endError: boolean;
}

export interface SlotRangeWrapper {
  slots: SlotRange[];
  isValid: boolean;
}
export interface DaySettingAttributes {
  minSlot: TimeSlot;
  maxSlot: TimeSlot;
  excludedSlots: TimeSlot[] | null;
  isOff: boolean;
}

export interface IDaySetting {
  day: Day;
  setting: IWorkingSetting;
}
export interface IWorkingSetting {
  minSlot: TimeSlot;
  maxSlot: TimeSlot;
  excludedSlots: TimeSlot[] | null;
}

export interface IDayOverride {
  day: string;
  setting: IWorkingSetting;
}

export interface IWorkingHours {
  daySettings: IDaySetting[];
}

export type WorkDay = {
  day: Day;
  setting: DaySettingAttributes;
};

export type DayOnOffMap = Partial<Record<Day, boolean>>;

export type SlotRangesMap = {
  [key: string]: SlotRangeWrapper;
};
